import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";
import SweetAlert from "sweetalert2-react";
import fire from "../config/Fire";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class AgregaEventos extends React.Component {
  constructor(props) {
    super(props);
    this.handleUploadAR = this.handleUploadAR.bind(this);
    this.cambiosInputs = this.cambiosInputs.bind(this);
  }
  //Declara los estadosd
  state = {
    open: false,
    link: "",
    contenido: "",
    fecha: null,
    precio: "",
    hashtag: "",
    titulo: "",
    imagen: null,
    uploadValue: 0,
    direccion: "",
    titulo1: ""
  };
  //Permite abrir el dialogo
  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };
  //Permite cerrar el dialogo
  handleClose = () => {
    this.setState({
      open: false,
      link: "",
      contenido: "",
      fecha: null,
      precio: "",
      hashtag: "",
      titulo: "",
      imagen: null,
      uploadValue: 0,
      titulo1: ""
    });
    this.setState({
      show: true,
      estado: "error",
      texto: "El evento no ha sido creado",
      titulo1: "Error"
    });
  };
  //Guarda lo que escribe el usuario en los inputs
  cambiosInputs(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  //Crea el evento
  subirEvento = () => {
    var record = null;
    if (this.state.uploadValue === 100) {
      record = {
        titulo: this.state.titulo,
        detalle: this.state.contenido,
        fecha: this.state.fecha,
        precio: this.state.precio,
        link: this.state.link,
        direccion: this.state.direccion,
        hashtag: this.state.hashtag,
        nombreimg: this.state.imagen.name
      };
      const key = new Date().getTime();
      fire
        .database()
        .ref()
        .child("Eventos")
        .child(key)
        .set(record);

      this.satisfactorio();
    } else {
      this.setTimeout();
    }
  };
  //Limpia los estados y abre el dialogo de success
  satisfactorio = () => {
    this.setState({
      open: false,
      link: "",
      contenido: "",
      fecha: null,
      precio: "",
      hashtag: "",
      titulo: "",
      imagen: null,
      uploadValue: 0,
      titulo1: ""
    });
    this.setState({
      show: true,
      estado: "success",
      texto: "El evento ha sido creado",
      titulo1: "¡Enhorabuena!"
    });
  };
  //Timeout para poder subir la imagen
  setTimeout = () => {
    setTimeout(this.subirEvento, 2000);
  };
  //Verifica quue no haya información con un título vacío
  handleNew = () => {
    if (
      this.state.titulo !== "" &&
      this.state.contenido !== "" &&
      this.state.fecha !== null &&
      this.state.precio !== "" &&
      this.state.hashtag !== "" &&
      this.state.imagen !== null
    ) {
      this.subirImagen();
      this.subirEvento();
    } else {
      alert("Debes ingresar toda la información del evento");
    }
  };
  //Sube la imagen a firebase
  subirImagen() {
    if (this.state.titulo != null) {
      const storageRef = fire
        .storage()
        .ref(`/Eventos/${this.state.titulo}/${this.state.imagen.name}`);
      const task = storageRef.put(this.state.imagen);
      task.on(
        "state_changed",
        snapshot => {
          let percentage =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.setState({
            uploadValue: percentage
          });
        },
        error => {},
        () => {
          storageRef.getDownloadURL().then(url => {
            this.setState({
              direccion: url
            });
          });
        }
      );
    }
  }
  //Guarda información de la imagen
  handleUploadAR(event) {
    const file = event.target.files[0];
    this.setState({ imagen: file });
  }
  //Renderiza la interfaz del diálogo
  render() {
    return (
      <div>
        <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleClickOpen}
          >
            Nuevo evento
          </Button>
          <Dialog
            open={this.state.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Nuevo evento"}
            </DialogTitle>
            <DialogContent>
              <TextField
                id="outlined-full-width"
                label="Título"
                fullWidth
                margin="normal"
                variant="outlined"
                name="titulo"
                onChange={this.cambiosInputs}
                value={this.state.titulo}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-full-width"
                label="Descripción"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="contenido"
                onChange={this.cambiosInputs}
                value={this.state.contenido}
              />
              <TextField
                id="date"
                label="Fecha del evento"
                type="date"
                defaultValue=""
                name="fecha"
                onChange={this.cambiosInputs}
                value={this.state.fecha}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-full-width"
                label="Precio"
                fullWidth
                margin="normal"
                variant="outlined"
                type="number"
                InputLabelProps={{
                  shrink: true
                }}
                name="precio"
                onChange={this.cambiosInputs}
                value={this.state.precio}
              />
              <TextField
                id="outlined-full-width"
                label="Link a boleto"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="link"
                onChange={this.cambiosInputs}
                value={this.state.link}
              />
              <TextField
                id="outlined-full-width"
                label="Ciudad"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                name="hashtag"
                onChange={this.cambiosInputs}
                value={this.state.hashtag}
              />
              <div>
                <br />
                <input
                  accept="image/*"
                  type="file"
                  disableUnderline={true}
                  name="Imagen"
                  onChange={this.handleUploadAR}
                />
                <br />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.handleNew} color="primary">
                Crear evento
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <SweetAlert
            show={this.state.show}
            title={this.state.titulo1}
            type={this.state.estado}
            text={this.state.texto}
            onConfirm={() => this.setState({ show: false })}
          />
        </div>
      </div>
    );
  }
}

export default AgregaEventos;
